export * from './montreal-smoked-meat-card';
